<template>
  <div class="departments">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Amended Leaves</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>

                  <li class="breadcrumb-item active">Amended Leaves</li>
                </ul>
              </div>
              <!-- <div class="col-md-3 float-right ml-auto">
                <button
                  class="btn btn-primary dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Status
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" @click="getAmendedLeaves">All</a>
                  <a class="dropdown-item" @click="getNewLeaveAmendment">New</a>
                  <a class="dropdown-item" @click="getApprovedLeaveAmendment"
                    >Approved</a
                  >
                  <a class="dropdown-item" @click="getRejectedLeaveAmendment"
                    >Rejected</a
                  >
                </div>
              </div> -->
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
                v-if="error"
              >
                <strong>Error!</strong> {{ error }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div>
                <v-data-table
                  :headers="headers"
                  :items="amendLeaves"
                  sort-by="name"
                  class="elevation-1"
                >
                  <template
                    v-slot:[`item.employeeLeave.fromDate`]="{ item }"
                  >
                    {{
                      item.employeeLeave.fromDate
                        ? new Date(item.employeeLeave.fromDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.employeeLeave.toDate`]="{ item }">
                    {{
                      item.employeeLeave.toDate
                        ? new Date(item.employeeLeave.toDate).toLocaleDateString()
                        : ""
                    }}
                  </template>

                  <template v-slot:[`item.amendDate`]="{ item }">
                    {{
                      item.amendDate
                        ? new Date(item.amendDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <!-- <a
                          class="dropdown-item"
                          @click="setLeaveStatus(item)"
                          v-if="item.status == 0"
                          ><i class="fa fa-pencil m-r-5"></i> Approve or
                          Reject</a
                        > -->
                        <a
                          class="dropdown-item"
                          @click="setLeaveStatus(item)"
                          v-if="item.status == 0"
                          ><i class="fa fa-pencil m-r-5"></i> Details
                        </a>
                        <!-- <a
                          class="dropdown-item"
                          @click="amendEmployeeLeaveByHOD(item)"
                          v-if="item.status == 1"
                          ><i class="fa fa-pencil m-r-5"></i> Amend Employee
                          Leave</a
                        > -->
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2
                      class="table-avatar blue-link"
                      v-if="item.employeeLeave"
                    >
                      <router-link
                        :to="{
                          name: 'employeedetail',
                          params: { id: item.employeeLeave.employee.id }
                        }"
                        class="avatar"
                        ><img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.employeeLeave.employee.passportPhoto"/>
                        <img
                          alt=""
                          :src="
                            media + item.employeeLeave.employee.passportPhoto
                          "
                          width="38"
                          v-if="item.employeeLeave.employee.passportPhoto"
                      /></router-link>
                      <router-link
                        :to="{
                          name: 'employeedetail',
                          params: { id: item.employeeLeave.employee.id }
                        }"
                        >{{
                          `${item.employeeLeave.employee.firstName} ${item.employeeLeave.employee.lastName}`
                        }}</router-link
                      >
                    </h2>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Amended
                      Leave
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Approve Leave Modal -->
        <v-dialog v-model="dialogStatus" max-width="500px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Amended Leave</h3>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <button type="button" class="close" @click="closeStatus">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h5>Reasons for Leave Amendment</h5>
                  <hr />
                  <div>{{ amendLeave.hodReason }}</div>
                  <hr />
                </div>
              </div>
              <p class="text-center">
                Are you sure want to approve for this amended leave?
              </p>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click="changeLeaveStatus(1)"
                      class="btn btn-primary continue-btn"
                      >Approve</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      @click="changeLeaveStatus(2)"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Decline</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Approve Leave Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService";
import { authenticationService } from "@/services/authenticationService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      headers: [
        {
          text: "Employee",
          align: "start",
          value: "profile"
        },
        { text: "LeaveType", value: "employeeLeave.leaveType.name" },
        { text: "From", value: "employeeLeave.fromDate" },
        { text: "To", value: "employeeLeave.toDate" },
        { text: "Amended Date", value: "amendDate" },
        { text: "Status", value: "stat" },
        { text: "Action", value: "actions", sortable: false }
      ],
      name: "",
      amendLeaves: [],
      amendLeave: {},
      submitted: false,
      loading: false,
      error: "",
      dialogStatus: false,
      currentUser: authenticationService.currentUserValue,
      fullName: ""
    };
  },

  watch: {
    dialogStatus(val) {
      val || this.closeStatus();
    }
  },

  methods: {
    setLeaveStatus(item) {
      this.amendLeave = item;
      this.dialogStatus = true;

      this.fullName =
        this.currentUser.employee.firstName +
        " " +
        this.currentUser.employee.lastName;
    },

    changeLeaveStatus(status) {
      this.submitted = true;
      this.amendLeave.status = status;
      const id = this.amendLeave.id;
      this.amendLeave.approvedBy = this.currentUser.employee.id;
      this.amendLeave.approvedDate = new Date();
      console.log(this.amendLeave.approvedDate);
      this.loading = true;
      employeeService.updateLeaveAmendment(id, this.amendLeave).then(
        id => {
          let currentUserDepart = JSON.parse(localStorage.getItem("currentUser"));
      employeeService
        .getDepartAmendedLeaves(
          currentUserDepart.employee.companyUnitId,
              currentUserDepart.employee.designation.departmentId
        ).then(o => {
            this.amendLeaves = o.filter(c => c.status == 0);
            this.closeStatus();
          });

          console.log("department approved", this.amendLeave);
        },
        error => {
          this.error = error;
          this.closeStatus();
          this.loading = false;
        }
      );
    },

    closeStatus() {
      this.dialogStatus = false;
    },

    getNewLeaveAmendment() {
      let currentUserDepart = JSON.parse(localStorage.getItem("currentUser"));
      employeeService
        .getDepartAmendedLeaves(
          currentUserDepart.employee.companyUnitId,
              currentUserDepart.employee.designation.departmentId
        ).then(
        o => {
          this.amendLeaves = o.filter(c => c.status == 0);
          this.closeStatus();
        },
        error => {
          error = error;
        }
      );
    },

    getAmendedLeaves() {
      let currentUserDepart = JSON.parse(localStorage.getItem("currentUser"));
      employeeService
        .getDepartAmendedLeaves(
          currentUserDepart.employee.companyUnitId,
              currentUserDepart.employee.designation.departmentId
        )
        .then(
          model => {
            this.amendLeaves = model;

            console.log(this.amendLeaves);
          },
          error => {
            error = error;
          }
        );
    },

    getApprovedLeaveAmendment() {
      let currentUserDepart = JSON.parse(localStorage.getItem("currentUser"));
      employeeService
        .getDepartAmendedLeaves(
          currentUserDepart.employee.companyUnitId,
              currentUserDepart.employee.designation.departmentId
        ).then(
        model => {
          this.amendLeaves = model.filter(c => c.status == 1);
          // console.log("leaves:", model[0]);
        },
        error => {
          error = error;
        }
      );
    },

    getRejectedLeaveAmendment() {
      let currentUserDepart = JSON.parse(localStorage.getItem("currentUser"));
      employeeService
        .getDepartAmendedLeaves(
          currentUserDepart.employee.companyUnitId,
              currentUserDepart.employee.designation.departmentId
        ).then(
        model => {
          this.amendLeaves = model.filter(c => c.status == 2);
          // console.log("leaves:", model[0]);
        },
        error => {
          error = error;
        }
      );
    }
  },

  mounted() {
    // this.getNewDepartment();
    this.getNewLeaveAmendment();
    // this.getAmendedLeaves();
  },
  name: "companydepartments"
};
</script>



// WEBPACK FOOTER //
// src/components/leaves/amendedLeaveByHODs.vue